<template>
  <div :class="{['text-' + align]: true, 'q-pa-md': padding}">
    <div class="text-h2">
      <component
        :is="component"
        :color="color"
        :size="size"
      />
    </div>
  </div>
</template>

<script>
import { QSpinner, QSpinnerDots } from 'quasar'

/**
 * Default loading spinner to use
 */
export default {
  components: {
    QSpinner, QSpinnerDots
  },
  props: {
    // Left, center, right
    align: {
      type: String,
      default: 'center'
    },
    // Show padding around the spinner
    padding: {
      type: Boolean,
      default: true
    },
    // Loading spinner component to use (refer to all options in Quasar docs).
    // Typically this should remain unchanged
    component: {
      type: String,
      default: 'q-spinner'
    },
    // Color of spinner
    color: {
      type: String
    },
    size: {
      type: [String, Number]
    }
  }
}
</script>
